import { CacheLocation } from 'msal';

import { AppConstants } from '../app/app-constants';

export const environment = {
  production: false,
  appName: 'GDHV IoT',
  title: 'Admin Portal',
  environmentName: 'DEV',
  apiBaseUrl: 'https://app-adminportalapi-dev.azurewebsites.net/api/',
  simulatorApiBaseUrl: 'https://app-websimulator-dev.azurewebsites.net',
  useMockComponents: false,
  authConfig: {
    auth: {
      clientId: '7ef7b9f8-ce2b-40cc-aa0f-eac3dbf3b8db',
      authority: 'https://glendimplexadb2c.b2clogin.com/tfp/glendimplexadb2c.onmicrosoft.com/B2C_1_AdminPortal_SignIn_SignUp',
      redirectUri: 'https://adminportal-dev.gdhv-iotdevtest.com/',
      postLogoutRedirectUri: 'https://adminportal-dev.gdhv-iotdevtest.com/',
      navigateToLoginRequestUrl: true,
      validateAuthority: true,
      knownAuthorities: ['https://glendimplexadb2c.b2clogin.com/tfp/glendimplexadb2c.onmicrosoft.com/B2C_1_AdminPortal_SignIn_SignUp', 
      'https://glendimplexadb2c.b2clogin.com/tfp/glendimplexadb2c.onmicrosoft.com/B2C_1_AdminPortal_PasswordReset']
    },
    cache: {
      cacheLocation: ('localStorage' as CacheLocation),
      storeAuthStateInCookie: AppConstants.isIE,
    },
  },
  msalConfig: {
    popUp: false,
    consentScopes: [
      'https://glendimplexadb2c.onmicrosoft.com/webapidev/read'
    ],
    unprotectedResources: [],
    protectedResourceMap: ([
      ['https://app-adminportalapi-dev.azurewebsites.net/', ['https://glendimplexadb2c.onmicrosoft.com/webapidev/read']]
    ] as [string, string[]][]),
    extraQueryParameters: {}
  },
  b2cPolicies: {
    authorities: {
      signUpSignIn: {
        name: 'B2C_1_AdminPortal_SignIn_SignUp',
        authority: 'https://glendimplexadb2c.b2clogin.com/tfp/glendimplexadb2c.onmicrosoft.com/B2C_1_AdminPortal_SignIn_SignUp'
      },
      passwordReset: {
        name: 'B2C_1_AdminPortal_PasswordReset',
        authority: 'https://glendimplexadb2c.b2clogin.com/tfp/glendimplexadb2c.onmicrosoft.com/B2C_1_AdminPortal_PasswordReset'
      },
    },
  },
  map: {
    urlTemplate: 'https://tile.openstreetmap.org/level/tileX/tileY.png'
  },
  appInsights: {
    instrumentationKey: '00ca3ea0-493e-43aa-bfc3-6082f0eff635',
    connectionString: 'InstrumentationKey=00ca3ea0-493e-43aa-bfc3-6082f0eff635'
  },
  products: {
    dimplexWifi: '1FC4EEC5-628E-4195-ACE9-588FD031A679',
    intuisOfrWifi: 'B942990D-FF3F-4BC8-B3BE-F1575F1FFF1E',
    mullerPhWifi: '1C387BE7-C29C-47E4-AE9F-78916380A565',
    optiflameV2: '4CE60877-7B6A-4559-90EB-7568291A73AB',
    optiflameV3: 'C629B1B1-D6CD-4987-A243-126F7D06E106',
    optiflameV4: 'F1395F22-15DA-46AD-9EDC-F0809708D085'
  },
  reporting: {
    dashboardUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item='Dashboard'!A1%3AAB36&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    firmwareUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item='Firmware%20Stats'!D21%3AS39&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    totalVsOnlineHubsUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=Total_Vs_Online_Hubs&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    totalVsOnlineAppliancesUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=Total_Vs_Online_Appliances&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    wiFiAppliancesUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=Wi-Fi_Appliances&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    dsmHubsUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=DSM_Hubs_Chart&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    applianceTypesUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=Appliance_Types&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    bleAppliancesUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=BLE_Appliances&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
    userRegistrationsUrl: "https://glendimplex.sharepoint.com/sites/GroupIoTTeam/_layouts/15/Doc.aspx?sourcedoc={4f5dc51e-1c00-4ff1-9bc9-fa3346dd98b9}&action=embedview&Item=User_Registrations&wdHideGridlines=True&wdInConfigurator=True&wdAllowInteractivity=True",
  },
  routing: {
    applianceDetails: "/devicemanagement/appliances/details/",
    applianceDiagnostic: "/reporting/appliancediagnostic/",
    hubDetails: "/devicemanagement/hubs/hubdetails/",
    directApplianceDetails: "/devicemanagement/directappliance/details/",
    userDetails: "/usermanagement/users/",
    applianceReleaseGroup: "/firmware/bluetooth/(bluetooth:release-group/",
    hubReleaseGroup: "/firmware/hub/(hub:release-group/",
    directApplianceReleaseGroup: "/firmware/appliance/(appliance:release-group/",
  },
  minFirmwareVersions: {
    hub: "129.12.4",
    gateway: "28", /*LTEGateway*/
    alta: "02.03.99",/*Dimplex Wi-Fi*/
    muller: "4.9.99",/*Muller PH Wifi*/
    alurad: "5.7.99",/*Intuis OFR WiFi*/
  }
};
